import { render, staticRenderFns } from "./HeaderImg.vue?vue&type=template&id=0d3e8532&scoped=true&functional=true&"
import script from "./HeaderImg.vue?vue&type=script&lang=ts&"
export * from "./HeaderImg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0d3e8532",
  null
  
)

export default component.exports